module.exports = __webpack_public_path__ + "static/media/Logo_Web.e5cafb6e.png";